import wixLocationFrontend from "wix-location-frontend";
import wixWindow from 'wix-window';
import { animateRepeater } from 'public/repeater-animation-handler.js';
import { searchProductByKeyword } from 'backend/search-products.web.js';
import { logInBackend, warnInBackend, infoInBackend, errorInBackend } from "backend/SSRLog.web.js";
import { masterPageOnReady, createLogger, withDuration } from "@hisense-staging/velo-npm";
import { debounce } from "public/utils";
import { handleBranchId } from "public/preview";
import { handleIsqa } from "public/qa";
import { GCPProjectId } from "public/consts";

function expandFooterItemsForMobile() {
    animateRepeater([
        { clickableBoxId: '#expndBox', expandedTextId: '#linksTxt', arrowId: '#expndBtn' },
        { clickableBoxId: '#expndBox1', expandedTextId: '#linksTxt1', arrowId: '#expndBtn1' }
    ]);
}

function initFooter() {
    const formFactor = wixWindow.formFactor;
    if (formFactor === "Mobile") {
        expandFooterItemsForMobile();
        $w("#expndBtn1").expand()
        $w('#expndBtn').expand();
    } else {
        $w('#linksTxt').expand();
        $w('#linksTxt1').expand();
    }
}



$w.onReady(async function () {
    const backendLogger = {
        log: logInBackend,
        warn: warnInBackend,
        error: errorInBackend,
        info: infoInBackend
    }
    const logger = await createLogger({ backendLogger, browserLogger: console, GCPProjectId });

    await withDuration("onReady", () => onReady(logger), logger);
    logger.debugLink();
});
async function onReady(logger) {
    // Handle isqa before branchId because if the isqa param is in session and not yet added in the URL,
    // handleIsqa will add it to the URL. This indicates that we are in QA mode, so we don't open the lightBox in preview mode.
    handleIsqa();
    handleBranchId();
    await masterPageOnReady($w, logger);

    initFooter();
    initNewSearch();
    return Promise.resolve()
}

function initNewSearch() {
    $w('#resultsRpt').onItemReady(($item, itemData) => {
        if (itemData.type === 'divider') {
            $item('#resultStateBox').changeState('divider');
            $item('#dividerItemTitle').text = itemData.title;
            return;
        }
        if (itemData.type === 'product page') {
            $item('#resultStateBox').changeState('product');
            $item('#productItemTitle').text = itemData.title;
            $item('#productItemTitle').onClick(() => {
                wixLocationFrontend.to(itemData.url);
            });
            return;
        }
        if (itemData.type === 'support page') {
            $item('#resultStateBox').changeState('support');
            $item('#supportItemTitle').text = itemData.title;
            $item('#supportItemTitle').onClick(() => {
                wixLocationFrontend.to(itemData.url);
            });
            return;
        }
    });

    const searchHandler = async () => {
        const debouncedSearch = debounce(() => searchProductByKeyword({ keyword: $w('#newSearchInput').value, limit: 10, isMarkSupportOnly: true }), 4000);
        $w('#newResultsBox').hide();
        const data = await debouncedSearch();

        if (!data.length) {
            $w('#newResultsBox').hide();
            return;
        }
        const supportProducts = data.map(product => {
            return {
                title: product.name,
                _id: `${product._id}-1`,
                url: `/support/${product.slug}`,
                type: 'support page'
            };
        });

        const storeProducts = data.filter(prod => !prod.isSupportOnly).map(product => {
            return {
                title: product.name,
                _id: product._id,
                url: product.productPageUrl,
                type: 'product page'
            };
        });
        const searchResults = [
            { title: 'Products', type: 'divider', _id: '0' },
            ...storeProducts,
            { title: 'Support', type: 'divider', _id: '1' },
            ...supportProducts,
        ]

        $w('#resultsRpt').data = searchResults;
        $w('#newResultsBox').show();
    }

    $w('#newSearchInput').onInput(searchHandler);
}